import { FC } from 'react';

import { BoxProps } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { BOX_SHADOW, DEFAULT_BORDER } from 'src/constants';

const BorderedCard: FC<BoxProps> = ({ children, sx, ...rest }) => {
    return (
        <Flex
            sx={{
                ...DEFAULT_BORDER,
                boxShadow: BOX_SHADOW,
                padding: '24px 16px',
                overflow: 'auto',
                justifyContent: 'space-between',
                flex: 1,
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Flex>
    );
};

export default BorderedCard;
